import { render, staticRenderFns } from "./PresentIllnessHistory.vue?vue&type=template&id=27c17ecc&"
import script from "./PresentIllnessHistory.vue?vue&type=script&lang=js&"
export * from "./PresentIllnessHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports